module.exports = __webpack_public_path__ + "img/daichuli.685d5c93.png";